export default __webpack_public_path__ + "static/media/badge_domain_flare.b5f29ca6.svg";